import { useState } from "react";
import { steps } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function SolutionsSection() {
  const [done, setDone] = useState<number[]>([]);

  const toggle = (order: number) => {
    setDone((prev) => (prev.includes(order) ? prev.filter((n) => n !== order) : [...prev, order]));
  };

  const reset = () => setDone([]);
  const progress = Math.round((done.length / steps.length) * 100);

  return (
    <section id="solutions" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="逐步排查"
          title="打不开的解决办法"
          desc="照着下面的顺序逐条尝试，每完成一项就勾选一次。右侧会实时显示你的自检进度，全部走完基本能定位问题所在。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_360px]">
          <div className="space-y-3">
            {steps.map((step) => {
              const checked = done.includes(step.order);
              return (
                <button
                  key={step.order}
                  type="button"
                  onClick={() => toggle(step.order)}
                  className={
                    checked
                      ? "flex w-full items-start gap-4 rounded-lg border border-primary-300 bg-primary-50 p-4 text-left transition-colors md:p-5"
                      : "flex w-full items-start gap-4 rounded-lg border border-background-200 bg-background-100/70 p-4 text-left transition-colors hover:border-primary-200 md:p-5"
                  }
                >
                  <span
                    className={
                      checked
                        ? "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50"
                        : "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 font-label text-sm font-bold text-foreground-600"
                    }
                  >
                    {checked ? <i className="ri-check-line"></i> : step.order}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-heading text-base font-bold text-foreground-950">{step.title}</span>
                    <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">{step.desc}</span>
                    <span className="mt-2 flex items-center gap-1.5 text-xs text-primary-700">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-lightbulb-line text-xs"></i>
                      </span>
                      {step.tip}
                    </span>
                  </span>
                </button>
              );
            })}
          </div>

          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="h-40 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20home%20desk%20at%20night%20with%20an%20open%20laptop%20and%20a%20cup%20of%20tea%2C%20warm%20amber%20lamp%20light%2C%20calm%20quiet%20atmosphere%2C%20editorial%20photography%20style%20with%20soft%20blurred%20background%2C%20no%20text%2C%20no%20people&width=1000&height=800&seq=hantv-fix-01&orientation=squarish"
                  alt="夜间在桌面电脑前按步骤排查访问问题的场景"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <p className="font-label text-xs text-foreground-500">自检进度</p>
                <p className="mt-1 font-heading text-3xl font-bold text-foreground-950">
                  {done.length}
                  <span className="text-lg text-foreground-400"> / {steps.length}</span>
                </p>
                <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-background-300">
                  <div
                    className="h-full rounded-full bg-primary-500 transition-all duration-300"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {progress === 100
                    ? "七步全部完成，若仍打不开，基本可以判定是地址已更换，请回到「最新地址动态」查看。"
                    : "建议从第一步开始，完成后勾选，直到定位到问题。"}
                </p>
                <button
                  type="button"
                  onClick={reset}
                  disabled={done.length === 0}
                  className="mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-restart-line"></i>
                  </span>
                  重置自检
                </button>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}